import { Component, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LOCALSTORAGEKEYS } from '../../../../_constants/localStorageKeys';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { CdnService } from '../../../../_services/_cdn/cdn.service';
import { LocalService } from '../../../../_services/_storage/local.service';
import { UserService } from '../../../../_services/_user/user.service';
import { SnackbarService } from '../../../../_services/snackbar/snackbar.service';

@Component({
    selector: 'lokos-role-request',
    templateUrl: './role-request.component.html',
    styleUrl: './role-request.component.scss',
    standalone: false,
})
export class RoleRequestComponent implements OnInit {
    applicationList: any = [];
    blockList: any = [];
    breadcrumbs = signal([
        { label: 'Home', link: '/main/dashboard/home' },
        { label: 'Role Request' },
    ]);
    CLIENT_IDS: any;
    columns = signal<any>([
        { field: 'index', label: 'sNo', sort: false },
        { field: 'first_name', label: 'name', sort: true },
        { field: 'phone', label: 'mobileNumber', sort: false },
        { field: 'email', label: 'emailId', sort: false },
        { field: 'application', label: 'source', sort: false, custom: true },
        { field: 'location', label: 'location', sort: false, custom: true },
        { field: 'role', label: 'role', sort: false, custom: true },
        {
            field: '_created',
            label: 'requestDateTime',
            sort: true,
            custom: true,
        },
        { field: 'status', label: 'status', sort: true, custom: true },
    ]);
    dataSource = signal<any>([]);
    districtList: any = [];
    form!: FormGroup;
    keyClockRoles: any = [];
    page = signal<number>(0);
    pageSize = signal<number>(10);
    stateList: any = [];
    totalElement = signal<number>(0);
    userProfile: any;
    userRoles: any;

    constructor(
        private appSettingService: AppSettingService,
        private cdnService: CdnService,
        private fb: FormBuilder,
        private localService: LocalService,
        private snackbarService: SnackbarService,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.CLIENT_IDS = this.appSettingService.clientIds;
        this.userRoles = this.localService.get('userRoles') || [];
        this.userProfile = this.localService.get('userProfile') || {};

        this.initFormControl();
        this.getStateList();
        this.getKeyClockRoles();
        this.getRequestHistory();

        this.form.patchValue({
            userId: this.userProfile?.sub,
            firstName: this.userProfile?.name,
            lastName: this.userProfile?.name,
            email: this.userProfile?.email,
            userName: this.userProfile?.preferred_username,
            phone: this.userProfile?.phone_number,
        });

        this.form.get('isApplication')?.valueChanges.subscribe(() => {
            this.keyClockRoles = [];
            this.form.patchValue({
                application: '',
                stateId: '',
                districtId: '',
                blockId: '',
                role: '',
            });
        });

        this.form.get('application')?.valueChanges.subscribe((obj) => {
            if (!obj) return;
            setTimeout(() => {
                this.getKeyClockRoles();
            });
        });

        this.form.get('stateId')?.valueChanges.subscribe((stateId) => {
            if (!stateId) return;
            this.getDistrictList(stateId);
            setTimeout(() => {
                this.getKeyClockRoles();
            });
        });

        this.form.get('districtId')?.valueChanges.subscribe((districtId) => {
            if (!districtId) return;
            this.getBlockList(this.form.get('stateId')?.value, districtId);
            setTimeout(() => {
                this.getKeyClockRoles();
            });
        });

        this.form.get('blockId')?.valueChanges.subscribe((blockId) => {
            if (!blockId) return;
            setTimeout(() => {
                this.getKeyClockRoles();
            });
        });

        this.form.get('role')?.valueChanges.subscribe((role) => {
            if (!role) return;
            if (this.userRoles.includes(role.name)) {
                if (this.form.value.blockId) {
                    const blockList = this.localService.get(
                        LOCALSTORAGEKEYS.BLOCKPERMISSIONS
                    );
                    const obj = blockList.find(
                        (block: any) =>
                            +block.block_id === +this.form.value.blockId &&
                            block.role === role.name
                    );
                    if (obj && obj.role === role.name) {
                        this.form.patchValue({ role: '' });
                        this.snackbarService.errorSnackbar(
                            'You already have this role'
                        );
                    }
                } else if (this.form.value.districtId) {
                    const districtList = this.localService.get(
                        LOCALSTORAGEKEYS.DISTRICTPERMISSIONS
                    );
                    const obj = districtList.find(
                        (district: any) =>
                            +district.district_id ===
                                +this.form.value.districtId &&
                            district.role === role.name
                    );
                    if (obj && obj.role === role.name) {
                        this.form.patchValue({ role: '' });
                        this.snackbarService.errorSnackbar(
                            'You already have this role'
                        );
                    }
                } else if (this.form.value.stateId) {
                    const stateList = this.localService.get(
                        LOCALSTORAGEKEYS.STATEPERMISSIONS
                    );
                    const obj = stateList.find(
                        (state: any) =>
                            +state.state_id === +this.form.value.stateId &&
                            state.role === role.name
                    );
                    if (obj && obj.role === role.name) {
                        this.form.patchValue({ role: '' });
                        this.snackbarService.errorSnackbar(
                            'You already have this role'
                        );
                    }
                } else {
                    if (this.userRoles.includes(role.name)) {
                        this.form.patchValue({ role: '' });
                        this.snackbarService.errorSnackbar(
                            'You already have this role'
                        );
                    }
                }
            }
        });
    }

    getRequestHistory() {
        this.userService
            .getUserRolesRequest(
                {
                    max_results: this.pageSize(),
                    offset: this.page() * this.pageSize(),
                },
                { max: this.pageSize(), offset: this.page() * this.pageSize() }
            )
            .subscribe({
                next: (response: any) => {
                    this.dataSource.set(response.hits);
                    this.totalElement.set(response.count);
                },
                error: () => {
                    /* no-op */
                },
            });
    }

    onPageChange(event: any) {
        this.page.set(event - 1);
        setTimeout(() => {
            this.getRequestHistory();
        });
    }

    onPageSizeChange(event: any) {
        this.pageSize.set(+event.target.value);
        this.page.set(0);
        setTimeout(() => {
            this.getRequestHistory();
        });
    }

    initFormControl() {
        this.form = this.fb.group({
            isApplication: ['No'],
            application: [''],
            stateId: [''],
            districtId: [''],
            blockId: [''],
            role: [''],
            userId: [''],
            clientId: [''],
            status: ['Pending'],
            firstName: [''],
            lastName: [''],
            email: [''],
            userName: [''],
            phone: [''],
            _type: ['keycloak.AccessRequest'],
        });
    }

    getStateList() {
        this.cdnService.getStatesList().subscribe((res: any) => {
            this.stateList = res;
        });
    }

    getDistrictList(stateId: string) {
        if (!stateId) return;
        this.cdnService.getDistrictsList(stateId).subscribe((res: any) => {
            this.districtList = res;
        });
    }

    getBlockList(stateId: string, districtId: string) {
        if (!stateId || !districtId) return;
        this.cdnService
            .getblockList(stateId, districtId)
            .subscribe((res: any) => {
                this.blockList = res;
            });
    }

    getAllClientsAppication() {
        this.userService.getAllClients().subscribe((res: any) => {
            this.applicationList = res;
        });
    }

    getKeyClockRoles() {
        this.keyClockRoles = [];
        this.form.patchValue({ role: '' });
        let client = '';
        if (this.form.get('isApplication')?.value === 'No') {
            if (this.form.value.blockId) {
                client = 'B-' + this.form.value.blockId;
            } else if (this.form.value.districtId) {
                client = 'D-' + this.form.value.districtId;
            } else if (this.form.value.stateId) {
                if (`${this.form.value.stateId}`.length === 1) {
                    client = 'S-0' + this.form.value.stateId;
                } else {
                    client = 'S-' + this.form.value.stateId;
                }
            } else {
                client = 'N-00';
            }
            const obj: any = this.CLIENT_IDS.find((obj: any) => {
                return obj.client === client;
            });

            if (obj) {
                this.form.patchValue({ clientId: obj.id });
            } else {
                this.form.patchValue({ clientId: '' });
                this.snackbarService.errorSnackbar('Client Id not found');
                return;
            }
        }

        if (this.form.get('isApplication')?.value === 'Yes') {
            this.form.patchValue({
                clientId: this.form.get('application')?.value.id,
            });
        }

        if (!this.form.value.clientId) {
            this.snackbarService.errorSnackbar('Client Id not found');
            return;
        }

        this.userService.getUserRoles(this.form.value.clientId).subscribe({
            next: (res: any) => {
                this.keyClockRoles = res.hits;
            },
            error: (err: any) => {
                this.snackbarService.errorSnackbar(
                    err.error.message || err.message
                );
            },
        });
    }

    onSubmitRequest() {
        if (this.form.invalid) {
            this.snackbarService.errorSnackbar(
                'Please fill all the required fields'
            );
            return;
        }
        const payload: any = {
            _type: 'keycloak.AccessRequest',
            name: this.form.get('userName')?.value,
            first_name: this.form.get('firstName')?.value,
            last_name: this.form.get('lastName')?.value,
            email: this.form.get('email')?.value,
            phone: this.form.get('phone')?.value,
            state: `${this.form.get('stateId')?.value}`.padStart(2, '0') || '-',
            district: `${this.form.get('districtId')?.value}` || '-',
            block: `${this.form.get('blockId')?.value}` || '-',
            application: {
                id: this.form.get('clientId')?.value,
                name: 'gram-nidhi',
                description: 'Gram Nidhi',
            },
            role: {
                id: this.form.get('role')?.value.id,
                name: this.form.get('role')?.value.name,
                description: this.form.get('role')?.value.description,
                composite: true,
                container_id: this.form.get('role')?.value.containerId,
                client_role: this.form.get('role')?.value.clientRole,
            },
            sub: this.form.get('userId')?.value,
            status: 'Pending',
        };

        Object.keys(payload).forEach((key) => {
            if (
                payload[key] === '' ||
                payload[key] === null ||
                payload[key] === undefined
            ) {
                delete payload[key];
            }
        });

        this.userService.submitRoleRequest(payload).subscribe({
            next: () => {
                this.snackbarService.successSnackbar(
                    'Request submitted successfully'
                );
                this.form.patchValue({
                    application: '',
                    stateId: '',
                    districtId: '',
                    blockId: '',
                    role: '',
                    clientId: '',
                });
                this.form.markAsUntouched();
                setTimeout(() => {
                    this.getKeyClockRoles();
                    this.getRequestHistory();
                });
            },
            error: (err: any) => {
                this.snackbarService.errorSnackbar(
                    err.error.message || err.message
                );
            },
        });
    }
}
